import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProductUnits(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/product_units/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProductUnit(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/product_units/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProductUnit(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/product_units/", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProductUnit(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/product_units/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
